import { Routes } from '@angular/router';
import { walletConnectGuard } from './guards/wallet-connect.guard';
import { adminGuard } from './guards/admin.guard';

export const appRoutes: Routes = [
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./features/onboarding/onboarding.component').then(
        m => m.OnboardingComponent,
      ),
  },
  {
    path: 'role-selection',
    loadComponent: () =>
      import('./features/role-selection/role-selection.component').then(
        m => m.RoleSelectionComponent,
      ),
    canActivate: [walletConnectGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [walletConnectGuard],
    children: [
      {
        path: 'market',
        loadComponent: () =>
          import('./features/market/market.component').then(
            m => m.MarketComponent,
          ),
      },
      {
        path: 'loan',
        loadComponent: () =>
          import('./features/loan/loan.component').then(
            m => m.LoanComponent,
          ),
      },
      {
        path: 'swap',
        loadComponent: () =>
          import('./features/swap/swap.component').then(
            m => m.SwapComponent,
          ),
      },
      {
        path: 'member',
        loadComponent: () =>
          import('./features/member-center/member-center.component').then(
            m => m.MemberCenterComponent,
          ),
      },
      {
        path: 'assets',
        loadComponent: () =>
          import('./features/my-assets/my-assets.component').then(
            m => m.MyAssetsComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'market',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/admin/admin-dashboard.component').then(
        m => m.AdminDashboardComponent,
      ),
    canActivate: [walletConnectGuard, adminGuard],
  },
  {
    path: 'egt',
    loadComponent: () =>
      import('./features/egt/egt-exchange.component').then(
        m => m.EgtExchangeComponent,
      ),
    canActivate: [walletConnectGuard],
  },
  {
    path: '**',
    redirectTo: 'onboarding',
  },
];
